import { useIntl } from 'react-intl';

import { notificationMessages } from '../messages.js';

/** @internal */
export function useNotificationMessages(props: {
  notificationEnabled: boolean;
}) {
  const intl = useIntl();
  const headingText = intl.formatMessage(
    notificationMessages.notificationsOverlayHeading,
    {
      notificationEnabled: props.notificationEnabled,
    },
  );

  const enabledInfo = intl.formatMessage(
    notificationMessages.notificationsEnabled,
  );
  const disabledInfo = intl.formatMessage(
    notificationMessages.notificationsDisabled,
  );

  return {
    headingText,
    infoText: props.notificationEnabled ? enabledInfo : disabledInfo,
  };
}
